import React from 'react';
export const BookDetails = () => {
  return <div className="py-16 bg-white relative" data-id="element-7">
      {/* Subtle corner element */}
      <div className="absolute bottom-0 left-0 w-16 h-16 md:w-24 md:h-24 opacity-30" data-id="element-8">
        <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full text-red-700" data-id="element-9">
          <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-10" />
        </svg>
      </div>
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-11">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 flex items-center" data-id="element-12">
          <span className="text-red-700 mr-2" data-id="element-13">★</span>
          Inside the book, you'll discover…
        </h2>
        <ul className="list-disc pl-6 space-y-4 text-lg text-gray-700 mb-12" data-id="element-14">
          <li data-id="element-15">
            <strong data-id="element-16">The anatomy of a school shooter:</strong> how bullying,
            neglect, and untreated trauma create a ticking time bomb.
          </li>
          <li data-id="element-17">
            <strong data-id="element-18">The rotten roots of the system:</strong> political
            cowardice, weak laws, and an education system blind to emotional
            pain.
          </li>
          <li data-id="element-19">
            <strong data-id="element-20">The voices among the rubble:</strong> parents, siblings, and
            survivors whose grief never makes it past the headlines.
          </li>
          <li data-id="element-21">
            <strong data-id="element-22">The mirror and the gun:</strong> the debate between arming
            teachers or investing in prevention — and what truly works.
          </li>
          <li data-id="element-23">
            <strong data-id="element-24">A possible vision of the future:</strong> what schools could
            look like if we finally chose courage over fear.
          </li>
        </ul>
        <div className="bg-gray-100 border-l-4 border-red-700 p-6 mb-12 relative overflow-hidden" data-id="element-25">
          <div className="absolute top-0 right-0 w-16 h-16 opacity-10" data-id="element-26">
            <div className="w-full h-1/3 bg-red-700" data-id="element-27"></div>
            <div className="w-full h-1/3 bg-white" data-id="element-28"></div>
            <div className="w-full h-1/3 bg-gray-700" data-id="element-29"></div>
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-30">
            Why this matters now
          </h3>
          <p className="text-lg text-gray-700" data-id="element-31">
            From 1999 to 2025, more than 440 lives have been lost to school
            shootings in the U.S. alone. Every year, the list grows. Every year,
            leaders promise change — and fail.
          </p>
          <p className="text-lg text-gray-700 mt-4" data-id="element-32">
            This book forces the question no one wants to answer:{' '}
            <span className="font-bold" data-id="element-33">
              How many more children must die before we act?
            </span>
          </p>
        </div>
        <div className="flex justify-center my-12 relative" data-id="element-34">
          <div className="absolute inset-0 rounded-lg border-2 border-transparent bg-gradient-to-br from-red-700/20 via-transparent to-gray-700/20" data-id="element-35"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/e7yfaJG88hDtwuupSVBYzv/library_when_scholls.png" alt="Students reading in school hallway" className="w-full max-w-2xl rounded-lg shadow-lg relative z-10" data-id="element-36" />
        </div>
      </div>
    </div>;
};